export const getYearOfBirth = (dateOfBirth?: string) => {
	return dateOfBirth?.split('-')[0];
};
